import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CareTEamService {
  progress$: any;
  private progressObserver: any;
  private progress: any;
  constructor(private genericService: GenericUtilityService) {
    this.progress$ = Observable.create((observer: any) => {
      this.progressObserver = observer
    })
  }
  getCareTeam(data: any){
    return this.genericService.ApiPostMethod("checkinform", "GetPatientCareTeam", data);
  }
  
  addCareTeam(data: any){
    return this.genericService.ApiPostMethod("checkinform", "CreateCareTeam", data);
  }
  
  deleteCreTeam(data: any){
    return this.genericService.ApiPostMethod("checkinform","DeleteCareTeam", data);
  }
  
  updateCareteam(data: any){
    return this.genericService.ApiPostMethod("checkinform","updateCareTeam", data);
  }
  
  getZipCityState(zipcode: string, patientAccount: string, practiceCode: string ) {
    return this.genericService.ApiGetMethod("checkinform/ZipCityState?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount + '&ZipCode=' + zipcode);
  }
  
  SearchProvider(dto: any) {
    var param = "";
    if(dto.FirstName){
      param += "&FirstName="+dto.FirstName;
    }
    if(dto.LastName){
      param += "&LastName="+dto.LastName;
    }
    if(dto.Number){
      param += "&Number="+dto.Number;
    }
    
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetProviderSearch?PatientAccount="+dto.PatientAccount+param);
  }
  
  // covid questionnire
  covidQuestionnire(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "InsertPatientSymtomsDrHaqWithoutPHR", data);
  }

  //rate for visit
  RateYourVisit(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "RateYourVisit", data);
  }

  
  GetZipCityState(zipcode: string, PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/ZipCityState?PracticeCode=" + PRACTICE_CODE + '&PatientAccount=' + PATIENT_ACCOUNT + '&ZipCode=' + zipcode);
  }


  
  //intake form
  GetIntakeFormSettings(PracticeCode: any, PatientAccount: any){
    return this.genericService.ApiGetMethodTalkphr("IntakeForm/IntakeSettings?PracticeCode=" + PracticeCode + '&PatientAccount=' + PatientAccount);
  }
  
  //consent settings
  getConsentFormSettings(PracticeCode: any, PatientAccount: any){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/ConsentFinancialFormSettings?PracticeCode=" + PracticeCode + '&PatientAccount=' + PatientAccount);
  }

  SaveSignature(files: any, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any,LastName:any,FirstName:any,formType:any) {
    
    return this.makeFileRequest(files, folder, PATIENT_ACCOUNT, PRACTICE_CODE,LastName,FirstName,formType);
  }
  private makeFileRequest(files: any, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any,LastName:any,FirstName:any,formType:any): Observable<any> {
    return Observable.create((observer: any) => {
      let formData: FormData = new FormData(),
      xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
        this.progressObserver.next(this.progress);
      };
      xhr.open('POST', this.genericService.getBaseIpTalkPhr() + folder, true);
      // for (let i = 0; i < files.length; i++) {
      formData.append("PatientAccount", PATIENT_ACCOUNT);
      formData.append("PracticeCode", PRACTICE_CODE);
      formData.append("FormType", formType);
      formData.append("Catagory", "Legal Forms");
      formData.append("CreatedBy", PATIENT_ACCOUNT);
      formData.append("LastName", LastName);
      formData.append("FirstName", FirstName);
      formData.append("Document", files);
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });
  }
}
